import { render, staticRenderFns } from "./lb-table.vue?vue&type=template&id=12534c1a&scoped=true"
import script from "./lb-table.vue?vue&type=script&lang=js"
export * from "./lb-table.vue?vue&type=script&lang=js"
import style0 from "./lb-table.vue?vue&type=style&index=0&id=12534c1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12534c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12534c1a')) {
      api.createRecord('12534c1a', component.options)
    } else {
      api.reload('12534c1a', component.options)
    }
    module.hot.accept("./lb-table.vue?vue&type=template&id=12534c1a&scoped=true", function () {
      api.rerender('12534c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lb-table3/lb-table.vue"
export default component.exports